export interface TrackingPricing {
  value: number;
  currency: string;
}

type PackageType = "basic" | "premium" | "upgrade_to_premium";

const PRICING_MAP: Record<string, Record<PackageType, TrackingPricing>> = {
  da: {
    basic: { value: 300, currency: "DKK" },
    premium: { value: 450, currency: "DKK" },
    upgrade_to_premium: { value: 200, currency: "DKK" },
  },
  se: {
    basic: { value: 450, currency: "SEK" },
    premium: { value: 660, currency: "SEK" },
    upgrade_to_premium: { value: 300, currency: "SEK" },
  },
  sv: {
    basic: { value: 450, currency: "SEK" },
    premium: { value: 660, currency: "SEK" },
    upgrade_to_premium: { value: 300, currency: "SEK" },
  },
  no: {
    basic: { value: 450, currency: "NOK" },
    premium: { value: 660, currency: "NOK" },
    upgrade_to_premium: { value: 310, currency: "NOK" },
  },
  de: {
    basic: { value: 40, currency: "EUR" },
    premium: { value: 60, currency: "EUR" },
    upgrade_to_premium: { value: 27, currency: "EUR" },
  },
  el: {
    basic: { value: 40, currency: "EUR" },
    premium: { value: 60, currency: "EUR" },
    upgrade_to_premium: { value: 27, currency: "EUR" },
  },
  es: {
    basic: { value: 40, currency: "EUR" },
    premium: { value: 60, currency: "EUR" },
    upgrade_to_premium: { value: 27, currency: "EUR" },
  },
  fr: {
    basic: { value: 40, currency: "EUR" },
    premium: { value: 60, currency: "EUR" },
    upgrade_to_premium: { value: 27, currency: "EUR" },
  },
  it: {
    basic: { value: 40, currency: "EUR" },
    premium: { value: 60, currency: "EUR" },
    upgrade_to_premium: { value: 27, currency: "EUR" },
  },
  nl: {
    basic: { value: 40, currency: "EUR" },
    premium: { value: 60, currency: "EUR" },
    upgrade_to_premium: { value: 27, currency: "EUR" },
  },
  pt: {
    basic: { value: 40, currency: "EUR" },
    premium: { value: 60, currency: "EUR" },
    upgrade_to_premium: { value: 27, currency: "EUR" },
  },
  fi: {
    basic: { value: 40, currency: "EUR" },
    premium: { value: 60, currency: "EUR" },
    upgrade_to_premium: { value: 27, currency: "EUR" },
  },
  is: {
    basic: { value: 6000, currency: "ISK" },
    premium: { value: 9000, currency: "ISK" },
    upgrade_to_premium: { value: 4000, currency: "ISK" },
  },
  fo: {
    basic: { value: 300, currency: "DKK" },
    premium: { value: 450, currency: "DKK" },
    upgrade_to_premium: { value: 200, currency: "DKK" },
  },
  en: {
    basic: { value: 47, currency: "USD" },
    premium: { value: 70, currency: "USD" },
    upgrade_to_premium: { value: 32, currency: "USD" },
  },
};

const DEFAULT_PRICING: TrackingPricing = { value: 47, currency: "USD" };

export function getTrackingPricing(
  locale: string,
  packageType?: string
): TrackingPricing {
  const pkg = (packageType || "basic") as PackageType;
  const localeMap = PRICING_MAP[locale];
  if (!localeMap) {
    return PRICING_MAP.en[pkg] || DEFAULT_PRICING;
  }
  return localeMap[pkg] || localeMap.basic;
}
